<template>
<v-card class='mt-2' >
  <v-card-title class='grey lighten-4 py-1 overline' >
    <!-- <v-btn small icon @click='getConfig' :loading='requests.configure.loading' ><v-icon small >replay</v-icon></v-btn> -->
    Connect to JotForm
    <v-spacer></v-spacer>
    <v-chip v-if='integration && integration.id' >
      <v-progress-circular v-if='requests.configure.loading' color='amber' indeterminate size=18 width=2 class='mr-2' ></v-progress-circular>
      <v-avatar ><v-icon color='success'>check_circle</v-icon></v-avatar>
      Installed
    </v-chip>
  </v-card-title>
  <v-divider/>
  <v-card-text>
    <v-layout>
      <v-flex xs12 >

        <v-text-field persistent-hint
          v-model='apikey'
          label='Your JotForm API key' hint='Create a key in JotForm from account settings -> API' >
        </v-text-field>
        <a href="https://jotform.com/myaccount/api" target="_blank" >
          Open Jotform Settings
        </a>

        </a>
        <a href="https://www.jotform.com/help/253-how-to-create-a-jotform-api-key/" target="_blank" >
          How to create your JotForm API Key
        </a>

        <p><strong>Important</strong> Make sure you grant "full access" to the key you create</p>

      </v-flex>
    </v-layout>
    <v-layout>
      <v-checkbox persistent-hint
        label='EU Datacenter'
        v-model='eu'
        class='pa-0'
        hint="TIP: If you don't know what this is, leave it as false" ></v-checkbox>
    </v-layout>
  </v-card-text>
  <v-divider class="mt-3" ></v-divider>
  <v-card-actions >
    <v-btn
      v-if='integration && integration.id'
      @click='confirmdelete=true' color='error' >Uninstall Integration</v-btn>
    <v-spacer/>
    <v-btn
      @click='configure'
      :loading='requests.configure.loading'
      color="primary" >Save</v-btn>
  </v-card-actions>

  <v-dialog v-model="confirmdelete" >
    <v-card>
      <v-card-title class='subtitle-1 overline' >
        Confirm delete this integration
      </v-card-title>
      <v-card-text>
        Are you sure you want to remove this integration?
      </v-card-text>
      <v-card-actions>
        <v-spacer/>
        <v-btn
          @click='uninstall' color='error' >Uninstall Integration</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</v-card>
</template>
<script>
export default {
  name: 'InstallJotForm',
  props: {
    integration: { type: Object, required: false }
  },
  data () {
    return {
      eu: false,
      apikey: null,
      settings: {},
      confirmdelete: false,
      requests: {
        configure: {
          resource: 'ag.integrations',
          extra: 'jotform/configure',
          status: 0
        },
        delete: {
          resource: 'ag.integrations',
          extra: 'jotform/delete'
        }
      }
    }
  },
  computed: {
    getConfigStatus () {
      return this.requests.configure.status
    },
    deleteStatus () {
      return this.requests.delete.status
    }
  },
  watch: {
    integration: {
      immediate: true,
      handler () {
        if (this.integration) {
          this.apikey = this.integration.token
          if (this.integration.settings) {
            this.eu = this.integration.settings.eu
          }
        }
      }
    },
    getConfigStatus () {
      if (this.getConfigStatus === 200) {
        this.$emit('ok', this.requests.configure)
        this.apikey = this.getObjectPath(this.requests, 'configure.result.token')
        this.settings = this.getObjectPath(this.requests, 'configure.result.settings')
        if (this.settings) {
          this.eu = this.settings.eu
        }
      }
    },
    deleteStatus () {
      if (this.deleteStatus === 204) {
        this.$emit('deleted', this.requests.delete)
      }
    }
  },
  methods: {
    configure () {
      let data = {token: this.apikey}
      if (this.eu === true) { data.eu = true }
      this.requests.configure.data = data
      this.$request('save', this.requests.configure)
    },
    uninstall () {
      if (this.integration && this.integration.id) {
        // this.requests.delete.resourceId = this.integration.id
        this.$request('delete', this.requests.delete)
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// InstallJotForm.vue?40ca27bf